import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import SideBar from "./SideBar";

/**
 * Custom route component for authenticated users
 * https://serverless-stack.com/chapters/create-a-route-that-redirects.html
 * 
 * @param {*} param0 
 */
export default function AuthenticatedRoute({ children, ...rest }) {
    const { pathname, search } = useLocation();
    const { isAuthenticated, business } = useAppContext();

    return (
        <Route {...rest}>
            <SideBar pageWrapId={"page-wrap"} outerContainerId={"App"} />

            <div id="page-wrap">
                <div className="mainContent">
                {
                    //If not authenticated or no business found, redirect to home 
                    (!isAuthenticated || !business|| business.enabled === false) && (
                        <Redirect to={
                            `/?redirect=${pathname}${search}`
                        } />
                    )
                }
                {
                    //If business is loaded, render children
                    business && 
                    business.subscriptionType !== null && (
                        children
                    )
                }
                {
                /* TODO!!!  IF business has gone through onboarding once, drop them into Home page */
                }
                </div>
            </div>

        </Route>
    );
}